// Which destination types THIS shop may use, as the API reported them.
//
// The server decides this, not the client: availableTypesFor() in
// src/routes/destinations.ts drops every type at release "hidden" unless the
// shop is listed in DESTINATION_PREVIEW_SHOP_DOMAINS. A hidden destination's
// code has landed but its live-account checks have not, so it must not be
// reachable, nor counted, nor named anywhere a merchant can see.
//
// Shared rather than per-page: Destinations.tsx needs the list to decide
// which cards exist, and Dashboard.tsx needs its length for the
// "N of M destinations connected" nudge. Those two answers have to agree,
// and when each page kept its own rule they did not: the dashboard counted
// the whole catalog and told merchants they had connected 6 of 11 when
// eleven was never on offer.

import { DESTINATION_TYPES, DESTINATION_CATALOG, type DestinationType } from "./destination-catalog";

/**
 * The shop's own list, filtered to types this build knows about.
 *
 * Falls back to every non-hidden catalog type when the response predates
 * `availableTypes` (an older cached payload). Showing the GA set is the safe
 * default: it understates what a preview shop may use, and never overstates
 * what an ordinary merchant may use.
 */
export function allTypesFrom(availableTypes?: string[]): DestinationType[] {
  if (availableTypes && availableTypes.length > 0) {
    return availableTypes.filter((t): t is DestinationType =>
      (DESTINATION_TYPES as readonly string[]).includes(t),
    );
  }
  return DESTINATION_TYPES.filter((t) => DESTINATION_CATALOG[t].release !== "hidden");
}
